import UI, { SkeletonProps } from "./UI";

const Skeleton = (props: SkeletonProps) => {
  return <UI {...props} />;
};

export default Skeleton;
